const MANGA_LIST = [
  { id: 1, title: 'キリスト教会の実態を暴露します' },
  { id: 2, title: 'ストーカーエリート' },
  { id: 3, title: 'キリスト教会と暴力' },
  { id: 4, title: 'キリスト教とセクハラについて' },
  { id: 5, title: '宗教戦争' },
  { id: 6, title: '消えたくなっちゃう時' },
  { id: 7, title: '教会に行く資格があるのは、誰？' },
];

export default MANGA_LIST;
